/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import {
  Image,
  Text,
  Space,
  Tab,
  Modal,
  Button,
} from '@cashfree-intl/coherent';
import { CUSTOM_COLORS } from 'constants/colors';
import { StepCircleProps, StepConnectorProps, StepItemProps } from '../types';

export const Container = styled(Space)`
  margin: 0 auto;
  padding: 20px;
  background-color: transparent;
  color: #333;
  border-radius: 8px;
  gap: 40px;
  max-width: 1104px;
`;

export const StepCircle = styled(Space)<StepCircleProps>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-family: ${props => props.theme.FONTS.bold};
  background-color: ${props =>
    props.completed
      ? CUSTOM_COLORS.COLOR_4CAF50
      : props.active
      ? CUSTOM_COLORS.COLOR_6B46C1
      : CUSTOM_COLORS.EEE6FF};
  color: ${props =>
    props.completed || props.active ? 'white' : CUSTOM_COLORS.D1C4E9};
  position: relative;
  z-index: 1;
`;

export const StepConnector = styled.div<StepConnectorProps>`
  height: 4px;
  width: calc(100% - 50px);
  background-color: ${({ completed }) =>
    completed ? CUSTOM_COLORS.COLOR_4CAF50 : CUSTOM_COLORS.E0DAF3};
  position: absolute;
  left: 47%;
  top: 50%;
  transform: translateX(-40%);
  z-index: 0;
`;
// Updated card with white background for entire accordion
export const Card = styled.div`
  background-color: ${CUSTOM_COLORS.WHITE};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

// Each substep item has its own border bottom
export const SubstepItem = styled.div`
  border-bottom: 1px solid ${CUSTOM_COLORS.FOFOFO};
  background-color: ${CUSTOM_COLORS.WHITE};
  padding: 32px;
  &:last-child {
    border-bottom: none;
  }
`;

export const SubstepHeader = styled(Space)`
  background-color: ${CUSTOM_COLORS.WHITE}; /* All headers are white */
  cursor: pointer;
`;

export const SubstepContent = styled.div`
  background-color: ${CUSTOM_COLORS.WHITE};
`;

export const DoneImage = styled(Image)`
  width: 70px;
  height: auto;
`;

export const StyledText = styled(Text)`
  font-size: 24px;
  line-height: 125%;
  font-family: ${props => props.theme.FONTS.semi_bold};
  color: ${CUSTOM_COLORS.MUTED_BLUE};
`;

export const StepWrapper = styled(Space)`
  flex: 1;
  position: relative;
  &:last-child {
    flex: unset;
  }
`;

export const SubStepTitle = styled(Text)`
  font-size: 18px;
  line-height: 125%;
  font-family: ${props => props.theme.FONTS.medium};
  color: ${props => props.color};
`;

export const SubStepDescription = styled(Text)`
  font-size: 16px;
  line-height: 125%;
  font-family: ${props => props.theme.FONTS.medium};
`;

export const NextStepsText = styled(Text)`
  font-size: 20px;
  line-height: 125%;
  font-family: ${props => props.theme.FONTS.normal};
  color: ${CUSTOM_COLORS.SECONDARY_6B6C7B};
`;

export const StyledTitle = styled(Text)`
  font-size: 32px;
  color: ${CUSTOM_COLORS.MUTED_BLUE};
  font-family: ${props => props.theme.FONTS.medium};
`;

export const StyledProductTitle = styled(Text)`
  font-size: 24px;
  line-height: 36px;
  font-family: ${props => props.theme.FONTS.normal};
`;

export const StyledDescriptionText = styled(Text)`
  text-align: left;
  line-height: 21px;
`;

export const StyledTitleText = styled(Text)`
  font-family: ${props => props.theme.FONTS.bold};
  font-size: 24px;
  line-height: normal;
  text-align: left;
  width: 75%;
`;

export const ContentContainer = styled.div`
  width: 100%;
  padding: 0rem 9rem;
`;

export const StyledIntegrationText = styled(Text)`
  font-family: ${props => props.theme.FONTS.semi_bold};
  font-size: 18px;
  line-height: normal;
`;

export const StepGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StepCard = styled(Space)`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 0.0625rem 0.25rem rgba(0, 0, 0, 0.05);
  padding: 32px;
  gap: 0.75rem;
`;

export const CardHeader = styled.div`
  margin-bottom: 0.5rem;
`;

export const ReviewBadge = styled.div`
  display: inline-block;
  padding: 0rem 0.55rem;
  background-color: ${CUSTOM_COLORS.FEF5E7};
  color: ${CUSTOM_COLORS.FF9500};
  border-radius: 0.5rem;
  font-size: 0.9rem;
  font-family: ${props => props.theme.FONTS.medium};
`;

export const StepItem = styled.div<StepItemProps>`
  border-radius: 8px;
  border: 1px solid
    ${({ isSelected }) =>
      isSelected ? CUSTOM_COLORS.LOADING : CUSTOM_COLORS.FOFOFO};
  padding: 1rem;
  transition: all 0.2s ease;
  &:hover {
    border: 1px solid ${CUSTOM_COLORS.PRIMARY_6930ca};
  }
`;

export const StepItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 1rem;
  height: 1rem;
  border: 0.125rem solid ${CUSTOM_COLORS.D9D9D9};
  background-color: ${CUSTOM_COLORS.D9D9D9};
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:checked {
    background-color: ${CUSTOM_COLORS.ACTIVE};
    border-color: ${CUSTOM_COLORS.ACTIVE};
  }
`;

export const StyledItemHeaderText = styled(Text)`
  color: ${({ isSelected }) =>
    isSelected ? CUSTOM_COLORS.MUTED_BLUE : CUSTOM_COLORS.SECONDARY_6B6C7B};
  &:hover {
    color: ${CUSTOM_COLORS.PRIMARY_6930ca};
  }
`;

// Styled components for specific elements
export const PlatformContainer = styled.div`
  min-width: 990px;
  margin: 0 auto;
  padding: 24px;
  max-width: 1108px;
`;

export const PlatformCard = styled.div`
  background-color: white;
  border-radius: 16px;
  border: 1px solid ${CUSTOM_COLORS.E5E7EB};
  overflow: hidden;
`;
export const VideoThumbnail = styled.div`
  width: 240px;
  height: 166px;
  display: flex;
  position: relative;
  overflow: hidden;
`;

export const StyledModal = styled(Modal)`
  .ui.embed {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  @media only screen and (max-width: 767px) {
    .ui.embed {
      border-radius: 0.5rem;
    }
  }
`;

// Custom styling for Tab component to ensure equal tab widths
export const StyledTab = styled(Tab)`
  .ui.pointing.secondary.menu {
    display: flex;
    width: 110%;
    height: 56px;
    .item {
      flex: 1;
      text-align: center;
      justify-content: center;
      font-size: 20px;
      font-family: ${props => props.theme.FONTS.medium};
      line-height: 18px;

      &.active {
        color: rgba(105, 48, 202, 1);
        border-color: rgba(105, 48, 202, 1);
        font-family: ${props => props.theme.FONTS.bold};
      }

      &:hover {
        color: rgba(105, 48, 202, 1);
      }
    }
  }
`;

export const CheckoutOption = styled(Space)`
  border-radius: 20px;
  border: 1px solid ${CUSTOM_COLORS.E5E7EB};
  padding: 1rem;
  flex: 1;
  position: relative;
  over-flow: hidden;
  cursor: pointer;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 200px;
`;

export const RecommendedBadge = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
`;

export const CircleIcon = styled(Space)`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${CUSTOM_COLORS.F3E8FF};
`;

export const StyledHeadingText = styled(Text)`
  font-size: 24px;
  font-style: normal;
  line-height: normal;
  font-family: ${props => props.theme.FONTS.bold};
  color: ${CUSTOM_COLORS.MUTED_BLUE};
`;

export const StyledBodyText = styled(Text)`
  line-height: 140%;
  font-family: ${props => props.theme.FONTS.normal};
`;

export const StyledAPIReferenceText = styled(Text)`
  font-size: 20px;
  line-height: 125%;
  font-family: ${props => props.theme.FONTS.normal};
  text-align: center;
`;

// Main content section
export const ContentPluginContainer = styled(Space)`
  max-width: 800px;
  margin: 0 auto;
`;

// Platform grid
export const PlatformGrid = styled(Space)`
  border: 1px solid ${CUSTOM_COLORS.E0E0E0};
  border-radius: 12px;
  padding: 40px;
  gap: 16px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const PlatformRow = styled(Space)`
  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }
`;
export const PlatformOption = styled(Space)`
  width: 100%;
  height: 56px;
  border: 1px solid ${CUSTOM_COLORS.E6E9EE};
  border-radius: 6px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  ${props =>
    props.selected &&
    `
    border-color: ${CUSTOM_COLORS.PRIMARY_6930ca};
    background-color:${CUSTOM_COLORS.FAF6FF};
    border-width: 2px;
    box-shadow: 0 0 0 1px rgba(100, 102, 233, 0.1);
  `}
`;

export const PlatformIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    filter: grayscale(100%) brightness(0.8) opacity(0.9);
  }
`;

// Selection notification and proceed button
export const PluginSelectionFooter = styled(Space)`
  margin-top: 24px;
  padding: 40px 0 0 0;
`;

export const PluginSelectionText = styled(Text)`
  font-size: 18px;
  margin: 0;
  font-family: ${props => props.theme.FONTS.normal};
  color: ${CUSTOM_COLORS.SECONDARY_6B6C7B};
  line-height: 125%;
  ${props =>
    props.selected &&
    `
    color: ${CUSTOM_COLORS.MUTED_BLUE};
     font-family: ${props => props.theme.FONTS.semi_bold};
  `}
`;

export const PluginFooterText = styled(Text)`
  font-size: 18px;
  margin: 0;
  font-family: ${props => props.theme.FONTS.normal};
  color: ${CUSTOM_COLORS.MUTED_BLUE};
  line-height: 125%;
`;

export const HybridOptionButton = styled(Button)`
  cursor: ${({ isSelected }) => (isSelected ? 'default' : 'pointer')};
  color: ${({ isSelected }) => !isSelected && CUSTOM_COLORS.AEABAB};
  border-color: ${({ isSelected }) => !isSelected && CUSTOM_COLORS.AEABAB};
  padding: 5px;
  font-size: 12px;
  font-family: ${props => props.theme.FONTS.normal};
`;

export const StepperWrapper = styled(Space)`
  margin: 0 20px;
  position: relative;
`;
